// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"72":"cb658992","161":"fcece96b","257":"fea6a2ce","661":"29a63629","761":"deafc1ec","921":"7344ebf0","983":"3907d415"}[chunkId] + ".css";
};